const en = {
	title: 'Label standard library',
	searchTips: 'Please enter a name',
	professionalLabel: 'Professional label',
	teamLabel: 'Team label',
	createLabel: 'Creare label',
	noDataTips: 'There is no label yet. Go and add it quickly',
	createProfessionalLabels: 'Create professional labels',
	cancel: 'cancel',
	confirm: 'confirm',
	labelName: 'Label name',
	desc: 'desc',
	tagNamePlaceholder: 'The number of words is limited to ${num}',
	descPlaceholder: 'The number of words is limited to ${num}',
	tagNameEmptytTips: 'Label name cannot be empty',
	majorLogo: 'Upload tag Icon',
	creater: 'creater: ',
	createTime: 'create time: ',
	add: 'add',
	delete: 'delete',
	teamLogo: 'upload team logo',
	tagsWaitingToBeAdded: 'tags waiting to be addd',
	createTeamTag: 'create team tag',
	labelDetails1: 'professional label details',
	labelDetails2: 'team tag details',
	addTag: 'add tag',
	modifySuccess: 'modify success',
	logo1: 'professional icon (click to modify)',
	logo2: 'professional icon (click to modify)',
	update: 'update',
	plTagMame: 'please enter label name',
	addTeamLogo: 'upload logo',
	projectManager: 'project manager',
	labelOwner: 'label owner',
	tipsTitle:
		'note: the following is the source information of the label, which is for reference only',
	tgaNamenoEmpty: 'tag name cannot be empt',
	nameCannotExceed: 'the label name cannot exceed 6 words',
	decsExceed: 'the label description cannot exceed 150 words',
	addMajorTag: 'add major	tag',
	addMajorTagDetail: 'major tag details',
	uploadMajorTaglogo: 'upload major logo',
	addTeamtag: 'add team tag',
};

export default en;
